import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
@Pipe({
    name: 'formIcon',
})
export class FormIcon implements PipeTransform {
    transform(value: number, list: any): string {
        let index = list.findIndex(x => x.id == value);
        return index > 0 ? list[index].image : 'assets/images/asset-list-item.svg';
    }
}
